//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.3.0.0 (NJsonSchema v11.2.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import * as http from "@angular/common/http";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const HMRC_API_BASE_URL = new InjectionToken<string>('HMRC_API_BASE_URL');

@Injectable()
export class BtnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getFormStructure(): Observable<GetBtnFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Btn/GetFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetBtnFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetBtnFormStructureOutput>;
        }));
    }

    protected processGetFormStructure(response: HttpResponseBase): Observable<GetBtnFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetBtnFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateBtn(body: SubmitBtnInput | undefined): Observable<ValidateResultDto> {
        let url_ = this.baseUrl + "/api/services/hmrc/Btn/ValidateBtn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateBtn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateBtn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResultDto>;
        }));
    }

    protected processValidateBtn(response: HttpResponseBase): Observable<ValidateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitBtn(body: SubmitBtnInput | undefined): Observable<HmrcPillar2OutputOfBtnResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/Btn/SubmitBtn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitBtn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitBtn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfBtnResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfBtnResult>;
        }));
    }

    protected processSubmitBtn(response: HttpResponseBase): Observable<HmrcPillar2OutputOfBtnResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfBtnResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class GirUploadServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    uploadGirFile(file: FileParameter | undefined): Observable<UploadGirFileOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/GirUpload/UploadGirFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadGirFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadGirFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadGirFileOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadGirFileOutput>;
        }));
    }

    protected processUploadGirFile(response: HttpResponseBase): Observable<UploadGirFileOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadGirFileOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitGir(body: SubmitGirInput | undefined): Observable<SubmitGirOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/GirUpload/SubmitGir";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitGir(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitGir(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SubmitGirOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SubmitGirOutput>;
        }));
    }

    protected processSubmitGir(response: HttpResponseBase): Observable<SubmitGirOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubmitGirOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HmrcOAuthServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getLoginUrl(scopes: string[] | null): Observable<GetHmrcLoginUrlOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/HmrcOAuth/GetLoginUrl?";
        if (scopes === undefined)
            throw new Error("The parameter 'scopes' must be defined.");
        else if(scopes !== null)
            scopes && scopes.forEach(item => { url_ += "Scopes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetHmrcLoginUrlOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetHmrcLoginUrlOutput>;
        }));
    }

    protected processGetLoginUrl(response: HttpResponseBase): Observable<GetHmrcLoginUrlOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetHmrcLoginUrlOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    exchangeCode(body: ExchangeHmrcCodeInput | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/services/hmrc/HmrcOAuth/ExchangeCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExchangeCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExchangeCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExchangeCode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getConnectionStatus(): Observable<HmrcConnectionStatusOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/HmrcOAuth/GetConnectionStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConnectionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConnectionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcConnectionStatusOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcConnectionStatusOutput>;
        }));
    }

    protected processGetConnectionStatus(response: HttpResponseBase): Observable<HmrcConnectionStatusOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcConnectionStatusOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    disconnectFromHmrc(): Observable<void> {
        let url_ = this.baseUrl + "/api/services/hmrc/HmrcOAuth/DisconnectFromHmrc";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDisconnectFromHmrc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDisconnectFromHmrc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDisconnectFromHmrc(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class HmrcUserManualsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param languageCode (optional) 
     * @return OK
     */
    getUserManual(languageCode: string | null | undefined): Observable<FileDownloadDto> {
        let url_ = this.baseUrl + "/api/services/hmrc/HmrcUserManuals/GetUserManual?";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserManual(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserManual(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileDownloadDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileDownloadDto>;
        }));
    }

    protected processGetUserManual(response: HttpResponseBase): Observable<FileDownloadDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileDownloadDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class OrnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getFormStructure(): Observable<GetOrnFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Orn/GetFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrnFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrnFormStructureOutput>;
        }));
    }

    protected processGetFormStructure(response: HttpResponseBase): Observable<GetOrnFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrnFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateOrn(body: SubmitOrnInput | undefined): Observable<ValidateResultDto> {
        let url_ = this.baseUrl + "/api/services/hmrc/Orn/ValidateOrn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateOrn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateOrn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResultDto>;
        }));
    }

    protected processValidateOrn(response: HttpResponseBase): Observable<ValidateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitOrn(body: SubmitOrnInput | undefined): Observable<HmrcPillar2OutputOfOrnResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/Orn/SubmitOrn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitOrn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitOrn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfOrnResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfOrnResult>;
        }));
    }

    protected processSubmitOrn(response: HttpResponseBase): Observable<HmrcPillar2OutputOfOrnResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfOrnResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    amendOrn(body: AmendOrnInput | undefined): Observable<HmrcPillar2OutputOfOrnResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/Orn/AmendOrn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAmendOrn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAmendOrn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfOrnResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfOrnResult>;
        }));
    }

    protected processAmendOrn(response: HttpResponseBase): Observable<HmrcPillar2OutputOfOrnResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfOrnResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RetrieveAccountActivityServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getOutputFormStructure(): Observable<GetRetrieveAccountActivityFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/RetrieveAccountActivity/GetOutputFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutputFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutputFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRetrieveAccountActivityFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRetrieveAccountActivityFormStructureOutput>;
        }));
    }

    protected processGetOutputFormStructure(response: HttpResponseBase): Observable<GetRetrieveAccountActivityFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRetrieveAccountActivityFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retrieveAccountActivity(body: RetrieveAccountActivityInput | undefined): Observable<HmrcPillar2OutputOfRetrieveAccountActivityResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/RetrieveAccountActivity/RetrieveAccountActivity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveAccountActivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveAccountActivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfRetrieveAccountActivityResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfRetrieveAccountActivityResult>;
        }));
    }

    protected processRetrieveAccountActivity(response: HttpResponseBase): Observable<HmrcPillar2OutputOfRetrieveAccountActivityResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfRetrieveAccountActivityResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RetrieveObligationsServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getOutputFormStructure(): Observable<GetRetrieveObligationsFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/RetrieveObligations/GetOutputFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutputFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutputFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRetrieveObligationsFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRetrieveObligationsFormStructureOutput>;
        }));
    }

    protected processGetOutputFormStructure(response: HttpResponseBase): Observable<GetRetrieveObligationsFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRetrieveObligationsFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retrieveObligations(body: RetrieveObligationsInput | undefined): Observable<HmrcPillar2OutputOfRetrieveObligationsResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/RetrieveObligations/RetrieveObligations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveObligations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveObligations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfRetrieveObligationsResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfRetrieveObligationsResult>;
        }));
    }

    protected processRetrieveObligations(response: HttpResponseBase): Observable<HmrcPillar2OutputOfRetrieveObligationsResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfRetrieveObligationsResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class RetrieveOrnServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getOutputFormStructure(): Observable<GetRetrieveOrnFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/RetrieveOrn/GetOutputFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOutputFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOutputFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRetrieveOrnFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRetrieveOrnFormStructureOutput>;
        }));
    }

    protected processGetOutputFormStructure(response: HttpResponseBase): Observable<GetRetrieveOrnFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRetrieveOrnFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retrieveOrn(body: RetrieveOrnInput | undefined): Observable<HmrcPillar2OutputOfRetrieveOrnResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/RetrieveOrn/RetrieveOrn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetrieveOrn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetrieveOrn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfRetrieveOrnResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfRetrieveOrnResult>;
        }));
    }

    protected processRetrieveOrn(response: HttpResponseBase): Observable<HmrcPillar2OutputOfRetrieveOrnResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfRetrieveOrnResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class SandboxServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getCreateTestUserFormStructure(): Observable<GetOrnFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Sandbox/GetCreateTestUserFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreateTestUserFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateTestUserFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrnFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrnFormStructureOutput>;
        }));
    }

    protected processGetCreateTestUserFormStructure(response: HttpResponseBase): Observable<GetOrnFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrnFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    getCreateTestOrganisationFormStructure(): Observable<GetOrnFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Sandbox/GetCreateTestOrganisationFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCreateTestOrganisationFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCreateTestOrganisationFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetOrnFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetOrnFormStructureOutput>;
        }));
    }

    protected processGetCreateTestOrganisationFormStructure(response: HttpResponseBase): Observable<GetOrnFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetOrnFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTestUser(body: CreateTestUserInput | undefined): Observable<SandboxOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Sandbox/CreateTestUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTestUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SandboxOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SandboxOutput>;
        }));
    }

    protected processCreateTestUser(response: HttpResponseBase): Observable<SandboxOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SandboxOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    createTestOrganisation(body: CreateTestOrganisationInput | undefined): Observable<SandboxOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Sandbox/CreateTestOrganisation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTestOrganisation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTestOrganisation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SandboxOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SandboxOutput>;
        }));
    }

    protected processCreateTestOrganisation(response: HttpResponseBase): Observable<SandboxOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SandboxOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable()
export class UktrServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(HMRC_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    getFormStructure(): Observable<GetUktrFormStructureOutput> {
        let url_ = this.baseUrl + "/api/services/hmrc/Uktr/GetFormStructure";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormStructure(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormStructure(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUktrFormStructureOutput>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUktrFormStructureOutput>;
        }));
    }

    protected processGetFormStructure(response: HttpResponseBase): Observable<GetUktrFormStructureOutput> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUktrFormStructureOutput.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validateUktr(body: SubmitUktrInput | undefined): Observable<ValidateResultDto> {
        let url_ = this.baseUrl + "/api/services/hmrc/Uktr/ValidateUktr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateUktr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateUktr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ValidateResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ValidateResultDto>;
        }));
    }

    protected processValidateUktr(response: HttpResponseBase): Observable<ValidateResultDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ValidateResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitUktr(body: SubmitUktrInput | undefined): Observable<HmrcPillar2OutputOfUktrResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/Uktr/SubmitUktr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitUktr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitUktr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfUktrResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfUktrResult>;
        }));
    }

    protected processSubmitUktr(response: HttpResponseBase): Observable<HmrcPillar2OutputOfUktrResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfUktrResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    amendUktr(body: AmendUktrInput | undefined): Observable<HmrcPillar2OutputOfUktrResult> {
        let url_ = this.baseUrl + "/api/services/hmrc/Uktr/AmendUktr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAmendUktr(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAmendUktr(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HmrcPillar2OutputOfUktrResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HmrcPillar2OutputOfUktrResult>;
        }));
    }

    protected processAmendUktr(response: HttpResponseBase): Observable<HmrcPillar2OutputOfUktrResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HmrcPillar2OutputOfUktrResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AmendOrnInput implements IAmendOrnInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: IAmendOrnInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): AmendOrnInput {
        data = typeof data === 'object' ? data : {};
        let result = new AmendOrnInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IAmendOrnInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class AmendUktrInput implements IAmendUktrInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: IAmendUktrInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): AmendUktrInput {
        data = typeof data === 'object' ? data : {};
        let result = new AmendUktrInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IAmendUktrInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class BtnResult implements IBtnResult {
    processingDate!: string | undefined;

    constructor(data?: IBtnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingDate = _data["processingDate"];
        }
    }

    static fromJS(data: any): BtnResult {
        data = typeof data === 'object' ? data : {};
        let result = new BtnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingDate"] = this.processingDate;
        return data;
    }
}

export interface IBtnResult {
    processingDate: string | undefined;
}

export class CreateTestOrganisationInput implements ICreateTestOrganisationInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: ICreateTestOrganisationInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): CreateTestOrganisationInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestOrganisationInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface ICreateTestOrganisationInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class CreateTestUserInput implements ICreateTestUserInput {
    formData!: string | undefined;

    constructor(data?: ICreateTestUserInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): CreateTestUserInput {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTestUserInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formData"] = this.formData;
        return data;
    }
}

export interface ICreateTestUserInput {
    formData: string | undefined;
}

export class ExchangeHmrcCodeInput implements IExchangeHmrcCodeInput {
    code!: string;
    state!: string;

    constructor(data?: IExchangeHmrcCodeInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): ExchangeHmrcCodeInput {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeHmrcCodeInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["state"] = this.state;
        return data;
    }
}

export interface IExchangeHmrcCodeInput {
    code: string;
    state: string;
}

export class FileDownloadDto implements IFileDownloadDto {
    fileName!: string | undefined;
    readonly content!: string | undefined;
    readonly mimeType!: string | undefined;

    constructor(data?: IFileDownloadDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            (<any>this).content = _data["content"];
            (<any>this).mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): FileDownloadDto {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IFileDownloadDto {
    fileName: string | undefined;
    content: string | undefined;
    mimeType: string | undefined;
}

export class GetBtnFormStructureOutput implements IGetBtnFormStructureOutput {
    formStructure!: string | undefined;

    constructor(data?: IGetBtnFormStructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formStructure = _data["formStructure"];
        }
    }

    static fromJS(data: any): GetBtnFormStructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetBtnFormStructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formStructure"] = this.formStructure;
        return data;
    }
}

export interface IGetBtnFormStructureOutput {
    formStructure: string | undefined;
}

export class GetHmrcLoginUrlOutput implements IGetHmrcLoginUrlOutput {
    loginUrl!: string | undefined;

    constructor(data?: IGetHmrcLoginUrlOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loginUrl = _data["loginUrl"];
        }
    }

    static fromJS(data: any): GetHmrcLoginUrlOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetHmrcLoginUrlOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loginUrl"] = this.loginUrl;
        return data;
    }
}

export interface IGetHmrcLoginUrlOutput {
    loginUrl: string | undefined;
}

export class GetOrnFormStructureOutput implements IGetOrnFormStructureOutput {
    formStructure!: string | undefined;

    constructor(data?: IGetOrnFormStructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formStructure = _data["formStructure"];
        }
    }

    static fromJS(data: any): GetOrnFormStructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetOrnFormStructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formStructure"] = this.formStructure;
        return data;
    }
}

export interface IGetOrnFormStructureOutput {
    formStructure: string | undefined;
}

export class GetRetrieveAccountActivityFormStructureOutput implements IGetRetrieveAccountActivityFormStructureOutput {
    formStructure!: string | undefined;

    constructor(data?: IGetRetrieveAccountActivityFormStructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formStructure = _data["formStructure"];
        }
    }

    static fromJS(data: any): GetRetrieveAccountActivityFormStructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRetrieveAccountActivityFormStructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formStructure"] = this.formStructure;
        return data;
    }
}

export interface IGetRetrieveAccountActivityFormStructureOutput {
    formStructure: string | undefined;
}

export class GetRetrieveObligationsFormStructureOutput implements IGetRetrieveObligationsFormStructureOutput {
    formStructure!: string | undefined;

    constructor(data?: IGetRetrieveObligationsFormStructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formStructure = _data["formStructure"];
        }
    }

    static fromJS(data: any): GetRetrieveObligationsFormStructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRetrieveObligationsFormStructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formStructure"] = this.formStructure;
        return data;
    }
}

export interface IGetRetrieveObligationsFormStructureOutput {
    formStructure: string | undefined;
}

export class GetRetrieveOrnFormStructureOutput implements IGetRetrieveOrnFormStructureOutput {
    formStructure!: string | undefined;

    constructor(data?: IGetRetrieveOrnFormStructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formStructure = _data["formStructure"];
        }
    }

    static fromJS(data: any): GetRetrieveOrnFormStructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetRetrieveOrnFormStructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formStructure"] = this.formStructure;
        return data;
    }
}

export interface IGetRetrieveOrnFormStructureOutput {
    formStructure: string | undefined;
}

export class GetUktrFormStructureOutput implements IGetUktrFormStructureOutput {
    formStructure!: string | undefined;

    constructor(data?: IGetUktrFormStructureOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formStructure = _data["formStructure"];
        }
    }

    static fromJS(data: any): GetUktrFormStructureOutput {
        data = typeof data === 'object' ? data : {};
        let result = new GetUktrFormStructureOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formStructure"] = this.formStructure;
        return data;
    }
}

export interface IGetUktrFormStructureOutput {
    formStructure: string | undefined;
}

export class HmrcConnectionStatusOutput implements IHmrcConnectionStatusOutput {
    isConnected!: boolean;
    scopes!: string[] | undefined;

    constructor(data?: IHmrcConnectionStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isConnected = _data["isConnected"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
        }
    }

    static fromJS(data: any): HmrcConnectionStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcConnectionStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isConnected"] = this.isConnected;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        return data;
    }
}

export interface IHmrcConnectionStatusOutput {
    isConnected: boolean;
    scopes: string[] | undefined;
}

export class HmrcPillar2Error implements IHmrcPillar2Error {
    message!: string | undefined;
    httpMethod!: string | undefined;
    requestUrl!: string | undefined;
    httpStatusCode!: number | undefined;
    responseBody!: string | undefined;

    constructor(data?: IHmrcPillar2Error) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.httpMethod = _data["httpMethod"];
            this.requestUrl = _data["requestUrl"];
            this.httpStatusCode = _data["httpStatusCode"];
            this.responseBody = _data["responseBody"];
        }
    }

    static fromJS(data: any): HmrcPillar2Error {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2Error();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["httpMethod"] = this.httpMethod;
        data["requestUrl"] = this.requestUrl;
        data["httpStatusCode"] = this.httpStatusCode;
        data["responseBody"] = this.responseBody;
        return data;
    }
}

export interface IHmrcPillar2Error {
    message: string | undefined;
    httpMethod: string | undefined;
    requestUrl: string | undefined;
    httpStatusCode: number | undefined;
    responseBody: string | undefined;
}

export class HmrcPillar2OutputOfBtnResult implements IHmrcPillar2OutputOfBtnResult {
    success!: boolean;
    result!: BtnResult | undefined;
    error!: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: IHmrcPillar2OutputOfBtnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.result = _data["result"] ? BtnResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? HmrcPillar2Error.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HmrcPillar2OutputOfBtnResult {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2OutputOfBtnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHmrcPillar2OutputOfBtnResult {
    success: boolean;
    result: BtnResult | undefined;
    error: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class HmrcPillar2OutputOfOrnResult implements IHmrcPillar2OutputOfOrnResult {
    success!: boolean;
    result!: OrnResult | undefined;
    error!: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: IHmrcPillar2OutputOfOrnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.result = _data["result"] ? OrnResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? HmrcPillar2Error.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HmrcPillar2OutputOfOrnResult {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2OutputOfOrnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHmrcPillar2OutputOfOrnResult {
    success: boolean;
    result: OrnResult | undefined;
    error: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class HmrcPillar2OutputOfRetrieveAccountActivityResult implements IHmrcPillar2OutputOfRetrieveAccountActivityResult {
    success!: boolean;
    result!: RetrieveAccountActivityResult | undefined;
    error!: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: IHmrcPillar2OutputOfRetrieveAccountActivityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.result = _data["result"] ? RetrieveAccountActivityResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? HmrcPillar2Error.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HmrcPillar2OutputOfRetrieveAccountActivityResult {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2OutputOfRetrieveAccountActivityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHmrcPillar2OutputOfRetrieveAccountActivityResult {
    success: boolean;
    result: RetrieveAccountActivityResult | undefined;
    error: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class HmrcPillar2OutputOfRetrieveObligationsResult implements IHmrcPillar2OutputOfRetrieveObligationsResult {
    success!: boolean;
    result!: RetrieveObligationsResult | undefined;
    error!: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: IHmrcPillar2OutputOfRetrieveObligationsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.result = _data["result"] ? RetrieveObligationsResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? HmrcPillar2Error.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HmrcPillar2OutputOfRetrieveObligationsResult {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2OutputOfRetrieveObligationsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHmrcPillar2OutputOfRetrieveObligationsResult {
    success: boolean;
    result: RetrieveObligationsResult | undefined;
    error: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class HmrcPillar2OutputOfRetrieveOrnResult implements IHmrcPillar2OutputOfRetrieveOrnResult {
    success!: boolean;
    result!: RetrieveOrnResult | undefined;
    error!: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: IHmrcPillar2OutputOfRetrieveOrnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.result = _data["result"] ? RetrieveOrnResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? HmrcPillar2Error.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HmrcPillar2OutputOfRetrieveOrnResult {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2OutputOfRetrieveOrnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHmrcPillar2OutputOfRetrieveOrnResult {
    success: boolean;
    result: RetrieveOrnResult | undefined;
    error: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class HmrcPillar2OutputOfUktrResult implements IHmrcPillar2OutputOfUktrResult {
    success!: boolean;
    result!: UktrResult | undefined;
    error!: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: IHmrcPillar2OutputOfUktrResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.result = _data["result"] ? UktrResult.fromJS(_data["result"]) : <any>undefined;
            this.error = _data["error"] ? HmrcPillar2Error.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): HmrcPillar2OutputOfUktrResult {
        data = typeof data === 'object' ? data : {};
        let result = new HmrcPillar2OutputOfUktrResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface IHmrcPillar2OutputOfUktrResult {
    success: boolean;
    result: UktrResult | undefined;
    error: HmrcPillar2Error | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class OrnResult implements IOrnResult {
    processingDate!: string | undefined;
    formBundleNumber!: string | undefined;

    constructor(data?: IOrnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingDate = _data["processingDate"];
            this.formBundleNumber = _data["formBundleNumber"];
        }
    }

    static fromJS(data: any): OrnResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingDate"] = this.processingDate;
        data["formBundleNumber"] = this.formBundleNumber;
        return data;
    }
}

export interface IOrnResult {
    processingDate: string | undefined;
    formBundleNumber: string | undefined;
}

export class ProtocolPdf implements IProtocolPdf {
    fileName!: string | undefined;
    content!: string | undefined;
    mimeType!: string | undefined;

    constructor(data?: IProtocolPdf) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.content = _data["content"];
            this.mimeType = _data["mimeType"];
        }
    }

    static fromJS(data: any): ProtocolPdf {
        data = typeof data === 'object' ? data : {};
        let result = new ProtocolPdf();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["content"] = this.content;
        data["mimeType"] = this.mimeType;
        return data;
    }
}

export interface IProtocolPdf {
    fileName: string | undefined;
    content: string | undefined;
    mimeType: string | undefined;
}

export class ResultMessageDto implements IResultMessageDto {
    type!: string | undefined;
    code!: string | undefined;
    reference!: string | undefined;
    labels!: ResultMessageLabelDto | undefined;

    constructor(data?: IResultMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.code = _data["code"];
            this.reference = _data["reference"];
            this.labels = _data["labels"] ? ResultMessageLabelDto.fromJS(_data["labels"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["code"] = this.code;
        data["reference"] = this.reference;
        data["labels"] = this.labels ? this.labels.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultMessageDto {
    type: string | undefined;
    code: string | undefined;
    reference: string | undefined;
    labels: ResultMessageLabelDto | undefined;
}

export class ResultMessageLabelDto implements IResultMessageLabelDto {
    en!: string | undefined;
    de!: string | undefined;

    constructor(data?: IResultMessageLabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.en = _data["en"];
            this.de = _data["de"];
        }
    }

    static fromJS(data: any): ResultMessageLabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ResultMessageLabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["en"] = this.en;
        data["de"] = this.de;
        return data;
    }
}

export interface IResultMessageLabelDto {
    en: string | undefined;
    de: string | undefined;
}

export class RetrieveAccountActivityInput implements IRetrieveAccountActivityInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: IRetrieveAccountActivityInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): RetrieveAccountActivityInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveAccountActivityInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IRetrieveAccountActivityInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class RetrieveAccountActivityResult implements IRetrieveAccountActivityResult {
    responseJson!: string | undefined;

    constructor(data?: IRetrieveAccountActivityResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseJson = _data["responseJson"];
        }
    }

    static fromJS(data: any): RetrieveAccountActivityResult {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveAccountActivityResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseJson"] = this.responseJson;
        return data;
    }
}

export interface IRetrieveAccountActivityResult {
    responseJson: string | undefined;
}

export class RetrieveObligationsInput implements IRetrieveObligationsInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: IRetrieveObligationsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): RetrieveObligationsInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveObligationsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IRetrieveObligationsInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class RetrieveObligationsResult implements IRetrieveObligationsResult {
    responseJson!: string | undefined;

    constructor(data?: IRetrieveObligationsResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseJson = _data["responseJson"];
        }
    }

    static fromJS(data: any): RetrieveObligationsResult {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveObligationsResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseJson"] = this.responseJson;
        return data;
    }
}

export interface IRetrieveObligationsResult {
    responseJson: string | undefined;
}

export class RetrieveOrnInput implements IRetrieveOrnInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: IRetrieveOrnInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): RetrieveOrnInput {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveOrnInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface IRetrieveOrnInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class RetrieveOrnResult implements IRetrieveOrnResult {
    responseJson!: string | undefined;

    constructor(data?: IRetrieveOrnResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseJson = _data["responseJson"];
        }
    }

    static fromJS(data: any): RetrieveOrnResult {
        data = typeof data === 'object' ? data : {};
        let result = new RetrieveOrnResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseJson"] = this.responseJson;
        return data;
    }
}

export interface IRetrieveOrnResult {
    responseJson: string | undefined;
}

export class SandboxError implements ISandboxError {
    message!: string | undefined;
    httpMethod!: string | undefined;
    requestUrl!: string | undefined;
    httpStatusCode!: number | undefined;
    responseBody!: string | undefined;

    constructor(data?: ISandboxError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.httpMethod = _data["httpMethod"];
            this.requestUrl = _data["requestUrl"];
            this.httpStatusCode = _data["httpStatusCode"];
            this.responseBody = _data["responseBody"];
        }
    }

    static fromJS(data: any): SandboxError {
        data = typeof data === 'object' ? data : {};
        let result = new SandboxError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["httpMethod"] = this.httpMethod;
        data["requestUrl"] = this.requestUrl;
        data["httpStatusCode"] = this.httpStatusCode;
        data["responseBody"] = this.responseBody;
        return data;
    }
}

export interface ISandboxError {
    message: string | undefined;
    httpMethod: string | undefined;
    requestUrl: string | undefined;
    httpStatusCode: number | undefined;
    responseBody: string | undefined;
}

export class SandboxOutput implements ISandboxOutput {
    success!: boolean;
    resultFormData!: string | undefined;
    error!: SandboxError | undefined;
    requiresHmrcAuthorization!: boolean;
    hmrcLoginUrl!: string | undefined;

    constructor(data?: ISandboxOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.resultFormData = _data["resultFormData"];
            this.error = _data["error"] ? SandboxError.fromJS(_data["error"]) : <any>undefined;
            this.requiresHmrcAuthorization = _data["requiresHmrcAuthorization"];
            this.hmrcLoginUrl = _data["hmrcLoginUrl"];
        }
    }

    static fromJS(data: any): SandboxOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SandboxOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["resultFormData"] = this.resultFormData;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["requiresHmrcAuthorization"] = this.requiresHmrcAuthorization;
        data["hmrcLoginUrl"] = this.hmrcLoginUrl;
        return data;
    }
}

export interface ISandboxOutput {
    success: boolean;
    resultFormData: string | undefined;
    error: SandboxError | undefined;
    requiresHmrcAuthorization: boolean;
    hmrcLoginUrl: string | undefined;
}

export class SubmitBtnInput implements ISubmitBtnInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: ISubmitBtnInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): SubmitBtnInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitBtnInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface ISubmitBtnInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class SubmitGirError implements ISubmitGirError {
    message!: string | undefined;
    httpMethod!: string | undefined;
    requestUrl!: string | undefined;
    httpStatusCode!: number | undefined;
    responseBody!: string | undefined;

    constructor(data?: ISubmitGirError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
            this.httpMethod = _data["httpMethod"];
            this.requestUrl = _data["requestUrl"];
            this.httpStatusCode = _data["httpStatusCode"];
            this.responseBody = _data["responseBody"];
        }
    }

    static fromJS(data: any): SubmitGirError {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitGirError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["httpMethod"] = this.httpMethod;
        data["requestUrl"] = this.requestUrl;
        data["httpStatusCode"] = this.httpStatusCode;
        data["responseBody"] = this.responseBody;
        return data;
    }
}

export interface ISubmitGirError {
    message: string | undefined;
    httpMethod: string | undefined;
    requestUrl: string | undefined;
    httpStatusCode: number | undefined;
    responseBody: string | undefined;
}

export class SubmitGirInput implements ISubmitGirInput {
    fileToken!: string;
    pillar2Id!: string;

    constructor(data?: ISubmitGirInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
            this.pillar2Id = _data["pillar2Id"];
        }
    }

    static fromJS(data: any): SubmitGirInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitGirInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        data["pillar2Id"] = this.pillar2Id;
        return data;
    }
}

export interface ISubmitGirInput {
    fileToken: string;
    pillar2Id: string;
}

export class SubmitGirOutput implements ISubmitGirOutput {
    success!: boolean;
    error!: SubmitGirError | undefined;
    protocolPdf!: ProtocolPdf | undefined;

    constructor(data?: ISubmitGirOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"];
            this.error = _data["error"] ? SubmitGirError.fromJS(_data["error"]) : <any>undefined;
            this.protocolPdf = _data["protocolPdf"] ? ProtocolPdf.fromJS(_data["protocolPdf"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SubmitGirOutput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitGirOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success;
        data["error"] = this.error ? this.error.toJSON() : <any>undefined;
        data["protocolPdf"] = this.protocolPdf ? this.protocolPdf.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISubmitGirOutput {
    success: boolean;
    error: SubmitGirError | undefined;
    protocolPdf: ProtocolPdf | undefined;
}

export class SubmitOrnInput implements ISubmitOrnInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: ISubmitOrnInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): SubmitOrnInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitOrnInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface ISubmitOrnInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class SubmitUktrInput implements ISubmitUktrInput {
    pillar2Id!: string | undefined;
    formData!: string | undefined;

    constructor(data?: ISubmitUktrInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pillar2Id = _data["pillar2Id"];
            this.formData = _data["formData"];
        }
    }

    static fromJS(data: any): SubmitUktrInput {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitUktrInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pillar2Id"] = this.pillar2Id;
        data["formData"] = this.formData;
        return data;
    }
}

export interface ISubmitUktrInput {
    pillar2Id: string | undefined;
    formData: string | undefined;
}

export class UktrResult implements IUktrResult {
    processingDate!: string | undefined;
    formBundleNumber!: string | undefined;
    chargeReference!: string | undefined;

    constructor(data?: IUktrResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processingDate = _data["processingDate"];
            this.formBundleNumber = _data["formBundleNumber"];
            this.chargeReference = _data["chargeReference"];
        }
    }

    static fromJS(data: any): UktrResult {
        data = typeof data === 'object' ? data : {};
        let result = new UktrResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processingDate"] = this.processingDate;
        data["formBundleNumber"] = this.formBundleNumber;
        data["chargeReference"] = this.chargeReference;
        return data;
    }
}

export interface IUktrResult {
    processingDate: string | undefined;
    formBundleNumber: string | undefined;
    chargeReference: string | undefined;
}

export class UploadGirFileOutput implements IUploadGirFileOutput {
    fileToken!: string | undefined;

    constructor(data?: IUploadGirFileOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileToken = _data["fileToken"];
        }
    }

    static fromJS(data: any): UploadGirFileOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UploadGirFileOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileToken"] = this.fileToken;
        return data;
    }
}

export interface IUploadGirFileOutput {
    fileToken: string | undefined;
}

export class ValidateResultDto implements IValidateResultDto {
    isValid!: boolean;
    description!: string | undefined;
    messages!: ResultMessageDto[] | undefined;

    constructor(data?: IValidateResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.description = _data["description"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(ResultMessageDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValidateResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["description"] = this.description;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item.toJSON());
        }
        return data;
    }
}

export interface IValidateResultDto {
    isValid: boolean;
    description: string | undefined;
    messages: ResultMessageDto[] | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}

// copied from HttpClient.request, for some reason its not a type there ¯\_(ツ)_/¯ 
export interface RequestOptions {
    body?: any;
    headers?: http.HttpHeaders | {
        [header: string]: string | string[];
    };
    context?: http.HttpContext;
    observe?: 'body';
    params?: http.HttpParams | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
    };
    reportProgress?: boolean;
    responseType: 'arraybuffer';
    withCredentials?: boolean;
    transferCache?: {
        includeHeaders?: string[];
    } | boolean;
}

export class ServiceProxyBase {
    async transformOptions(options: RequestOptions): Promise<RequestOptions> {
        return options
    }
}